import {IConsent} from './types'

export const HOME_PATH = 'home'
export const SIGN_TYPE_PATH = 'sign-type'
export const SINGLE_SIGN_PATH = 'single-sign'
export const ABOUT_PATH = 'about'
export const PROFILE_PATH = 'profile'
export const LOGIN_PATH = 'login'
export const LOGOUT_PATH = 'logout'

export const getDefaultConsent = (): IConsent => ({
  id: '1',
  owner: '',
  name: '',
  projectName: ''
})